<template>
  <v-container
    id="optimap"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <v-card
          style="min-height: 500px;"
        >
          <v-tabs
            v-model="activeTab"
            background-color="primary"
            dark
          >
            <v-tab
            key="map"
            >
              Map
            </v-tab>
            <v-tab
            key="not-map"
            >
              NOT Map
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item
              key="map"
            >
              <v-navigation-drawer
                v-model="drawerTowerDetails"
                absolute
                right
                style="z-index: 9999"
              >
                <template v-slot:prepend>
                  <v-btn
                    block
                    class="warning"
                    @click="drawerTowerDetails = false"
                  >
                    Close
                  </v-btn>
                </template>

                <v-divider></v-divider>
                <pow-heat-tower-details
                  v-show="selectedPreviewTower.id > 0"
                  :tower="selectedPreviewTower"
                ></pow-heat-tower-details>
                <pow-heat-marker-details
                  v-show="selectedPreviewTower.id === 0"
                  :item="markerDetails"
                  v-on:itemCreated="onTowerCreated"
                  ></pow-heat-marker-details>
              </v-navigation-drawer>

              <l-map
                style="height: 75vh; width: inherit;"
                id="map"
                ref="vwFootMap"
                :zoom.sync="zoom"
                no-blocking-animations
                :center.sync="center"
                :bounds.sync="vwFootMapBounds"
                @ready="vwFootMapReady"
                @update:center="onMapCentered"
                @click="onMapClicked"
                @overlayadd="onOverlayAdded"
              >
                <l-control-layers
                  position="topright"
                ></l-control-layers>
                <l-geo-json :geojson="geojson"></l-geo-json>
                <l-marker
                  :lat-lng="markerDetails"
                  :options.sync="vwFootMarkerOptions"
                >
                  <l-icon
                    :icon-anchor="staticAnchor"
                  >
                    <img src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png">
                  </l-icon>
                </l-marker>
                <l-geo-json
                  :geojson="geojsonCircum"
                  :options-style="geojsonCircumStyle"
                ></l-geo-json>
                <l-layer-group
                  v-for="cloudTower in cloudTowers"
                  ref="cloudGroupTowers"
                  :key="cloudTower.rowkey"
                  :visible.sync="cloudTower.visible"
                >
                  <l-marker
                    :lat-lng="getMarkerPosFromTower(cloudTower)"
                    @click="onCloudMarkerClicked(cloudTower)"
                  >
                    <l-tooltip
                      :content="cloudTower.name"
                    ></l-tooltip>
                    <l-icon
                      :icon-anchor="staticAnchor"
                    >
                      <img src="https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-orange.png">
                    </l-icon>
                  </l-marker>
                </l-layer-group>
                <l-layer-group
                  v-for="towerPreview in cloudTowerPreviews"
                  ref="cloudGroupTowerConfigPrev"
                  :key="towerPreview.rowkey + towerPreview.tower_rowkey"
                  :visible.sync="towerPreview.visible"
                >
                  <l-geo-json
                    :geojson="getTowerOutline(towerPreview)"
                    :options-style="geojsonCircumStyle"
                  ></l-geo-json>
                  <l-geo-json
                    v-if="towerPreview.visible"
                    :geojson.sync="towerPreview.geojson"
                    :options-style="geojsonFootprintStyle"
                  ></l-geo-json>
                </l-layer-group>
                <l-tile-layer
                  v-for="layer in tileProviders"
                  :key="layer.name"
                  :url="layer.url"
                  :visible="layer.visible"
                  :name="layer.name"
                  layer-type="base"
                >
                </l-tile-layer>
                <l-wms-tile-layer
                  v-for="layer in tileProvidersOverlay"
                  :key="layer.name"
                  :base-url="layer.url"
                  :layers="layer.layers"
                  :visible="layer.visible"
                  :name="layer.name"
                  :transparent="layer.transparent"
                  :format="layer.format"
                  :tms="layer.tms"
                  :opacity="layer.opacity"
                  layer-type="overlay"
                  @click="wmsClicked"
                >
                </l-wms-tile-layer>
              </l-map>
            </v-tab-item>
            <v-tab-item
              key="not-map"
            >
              <pow-table-tower-config></pow-table-tower-config>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import axios from 'axios'
  import { LMap, LMarker, LTileLayer, LWMSTileLayer, LGeoJson, LLayerGroup, LControlLayers, LIcon, LTooltip } from 'vue2-leaflet'
  // import L from 'leaflet'
  import 'leaflet/dist/leaflet.css'
  import mapboxgl from 'mapbox-gl'
  import 'mapbox-gl-leaflet'
  import 'mapbox-gl/dist/mapbox-gl.css'
  var turf = require('@turf/turf')
  window.mapboxgl = mapboxgl // mapbox-gl-leaflet expects this to be global
  export default {
    name: 'Optimap',

    components: {
      'l-map': LMap,
      'l-geo-json': LGeoJson,
      'l-tile-layer': LTileLayer,
      'l-marker': LMarker,
      'l-layer-group': LLayerGroup,
      'l-control-layers': LControlLayers,
      'l-icon': LIcon,
      'l-wms-tile-layer': LWMSTileLayer,
      'l-tooltip': LTooltip,
      PowTableTowerConfig: () => import('@/components/pow/PowTableTowerConfig'),
      PowHeatTowerDetails: () => import('@/components/pow/HeatTowerDetails'),
      PowHeatMarkerDetails: () => import('@/components/pow/HeatMarkerDetails'),
    },

    data: () => ({
      activeTab: 0,
      drawer: null,
      drawerRight: null,
      drawerTowerDetails: null,
      right: false,
      left: false,
      tileProviders: [
        {
          name: 'Satellite Mapbox Base',
          visible: false,
          attribution: '',
          url: 'https://api.mapbox.com/styles/v1/jdietrich/ckb86tww8021u1imi6yc0j0up/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamRpZXRyaWNoIiwiYSI6ImNrYjdjOTY4YTA0ZGIzMHM3MDVtYW54dHMifQ.G39kMitwQre3y48CHIGhwQ',
        },
        {
          name: 'Streets Mapbox grayscale',
          visible: true,
          attribution: '',
          url: 'https://api.tiles.mapbox.com/v4/mapbox.light/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
        },
        {
          name: 'Streets Mapbox',
          visible: false,
          attribution: '',
          url: 'https://api.tiles.mapbox.com/v4/mapbox.streets/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw',
        },
        {
          name: 'OpenStreetMap Base',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
        {

          name: 'OpenTopoMap Base',
          visible: false,
          url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
          attribution:
            'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
      ],
      tileProvidersOverlay: [
        {
          name: 'Satellite Mapbox',
          visible: false,
          attribution: '',
          tms: true,
          // /v4/{tileset_id}/{zoom}/{x}/{y}{@2x}.{format}
          url: 'https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.jpg90?access_token=pk.eyJ1IjoiamRpZXRyaWNoIiwiYSI6ImNrYjdjOTY4YTA0ZGIzMHM3MDVtYW54dHMifQ.G39kMitwQre3y48CHIGhwQ',
          options: {},
          opacity: 1.0,
        },
        {
          name: 'Provider Overlay',
          visible: false,
          attribution: '',
          tms: true,
          url: 'https://b.tiles.mapbox.com/v4/fcc.connect2compete/{z}/{x}/{-y}.png?access_token=pk.eyJ1IjoiZmNjIiwiYSI6InBiaGMyLU0ifQ.LOmVYpUCFv2yWpbvxDdQNg',
          options: {},
          opacity: 1.0,
        },
        {
          name: 'Esri',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: false,
          format: 'image/png',
          layers: 'tester:World_Imagery',
        },
        {
          name: 'CN BufferOutline',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: false,
          format: 'image/png',
          layers: 'tester:cnbufferoutline',
          transparent: true,
          tms: false,

          attribution: 'Weather data © 2012 IEM Nexrad',
          options: {
            stroke: '#555555',
            'stroke-width': 1,
            'stroke-opacity': 0.2,
            fill: '#555555',
            weight: 1,
            color: 'orange',
            dashArray: '3',
            fillOpacity: 0.01,

          },
          opacity: 0.3,

        },
        {
          name: 'San Juan Outline',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: false,
          format: 'image/png',
          layers: 'tester:SanJoaquinCoOutline',
          transparent: true,
          tms: false,

          attribution: 'Weather data © 2012 IEM Nexrad',
          options: {
            stroke: '#555555',
            'stroke-width': 1,
            'stroke-opacity': 0.2,
            fill: '#555555',
            weight: 1,
            color: 'orange',
            dashArray: '3',
            fillOpacity: 0.01,

          },
          opacity: 0.4,

        },
        {
          name: 'Stan Co Outline',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: false,
          tms: false,
          format: 'image/png',
          layers: 'tester:StanislausCoOutline',
          transparent: true,
          attribution: 'Weather data © 2012 IEM Nexrad',
          options: {
            stroke: '#555555',
            'stroke-width': 1,
            'stroke-opacity': 0.2,
            fill: '#555555',
            weight: 1,
            color: 'orange',
            dashArray: '3',
            fillOpacity: 0.01,

          },
          opacity: 0.4,

        },
        {
          name: 'Vast Lines',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: true,
          tms: false,
          format: 'image/png',
          layers: 'tester:vastNorthValleyLines,tester:vastNorthValleyEnds',
          transparent: true,
          attribution: 'Vast',
          options: {
            // "stroke": "#16ff22",
            'stroke-width': 3,
            'stroke-opacity': 1,
            fill: '#16ff22',
            weight: 3,
            color: '#16ff22',
            fillOpacity: 1.0,

          },
          opacity: 1,

        },
        {
          name: 'VW-Customers',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: true,
          tms: false,
          format: 'image/png',
          layers: 'tester:customer_locs',
          transparent: true,
          attribution: 'VW',
          options: {
            // "stroke": "#16ff22",
            'stroke-width': 3,
            'stroke-opacity': 1,
            fill: '#16ff22',
            weight: 3,
            color: '#16ff22',
            fillOpacity: 1.0,

          },
          opacity: 1,

        },
        {
          name: 'ALL-ADDRESS',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: false,
          tms: false,
          format: 'image/png',
          layers: 'tester:address_locs_all',
          transparent: true,
          attribution: 'VW',
          options: {
            // "stroke": "#16ff22",
            'stroke-width': 3,
            'stroke-opacity': 1,
            fill: '#16ff22',
            weight: 3,
            color: '#16ff22',
            fillOpacity: 1.0,

          },
          opacity: 1,

        },
        {
          name: 'Grid LINES',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: true,
          tms: false,
          format: 'image/png',
          layers: 'tester:squareGRID',
          transparent: true,
          attribution: 'Vast',
          options: {
            // "stroke": "#16ff22",
            'stroke-width': 3,
            'stroke-opacity': 1,
            fill: '#16ff22',
            weight: 3,
            color: '#16ff22',
            fillOpacity: 1.0,

          },
          opacity: 1,

        },
        {
          name: 'Grid POINTS',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: true,
          tms: false,
          format: 'image/png',
          layers: 'tester:pointGRIDpkg',
          transparent: true,
          attribution: 'Vast',
          options: {
            // "stroke": "#16ff22",
            'stroke-width': 3,
            'stroke-opacity': 1,
            fill: '#16ff22',
            weight: 3,
            color: '#16ff22',
            fillOpacity: 1.0,

          },
          opacity: 1,

        },
        {
          name: 'Demo Towers',
          url: 'https://geoserver.home.modz-inc.com/geoserver/tester/wms?',
          visible: true,
          tms: false,
          format: 'image/png',
          layers: 'tester:FOURPOINT',
          transparent: true,
          attribution: 'POW',
          options: {
            // "stroke": "#16ff22",
            'stroke-width': 3,
            'stroke-opacity': 1,
            fill: '#16ff22',
            weight: 3,
            color: '#16ff22',
            fillOpacity: 1.0,

          },
          opacity: 1,

        },

      ],
      zoom: 12,
      radius: 3,
      center: [37.878574, -121.061438],
      geojson: null,
      geojsonFootprintStyle: {
        stroke: '#555555',
        'stroke-width': 1,
        'stroke-opacity': 1,
        fill: '#555555',
        'fill-opacity': 0.5,
        weight: 2,
        opacity: 1,
        color: 'blue',
        dashArray: '3',
        fillOpacity: 0.08,
      },
      geojsonCircum: null,
      mapGrid: null,
      pointGrid: null,
      pointPosText: 0,
      pointGridCols: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
                      'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'ag', 'ah', 'ai', 'aj', 'ak', 'al', 'am', 'an', 'ao', 'ap', 'aq', 'ar', 'as', 'at', 'au', 'av', 'aw', 'ax', 'ay', 'az',
                      'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bk', 'bl', 'bm', 'bn', 'bo', 'bp', 'bq', 'br', 'bs', 'bt', 'bu', 'bv', 'bw', 'bx', 'by', 'bz',
                      'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'cg', 'ch', 'ci', 'cj', 'ck', 'cl', 'cm', 'cn', 'co', 'cp', 'cq', 'cr', 'cs', 'ct', 'cu', 'cv', 'cw', 'cx', 'cy', 'cz',
                      'da', 'db', 'dc', 'dd', 'de', 'df', 'dg', 'dh', 'di', 'dj', 'dk', 'dl', 'dm', 'dn', 'do', 'dp', 'dq', 'dr', 'ds', 'dt', 'du', 'dv', 'dw', 'dx', 'dy', 'dz'],
      mapGridOptions: {
        stroke: '#555555',
        'stroke-width': 0.5,
        'stroke-opacity': 0.1,
        fill: '#555555',
        weight: 0.8,
        color: 'white',
        dashArray: '8',
        fillOpacity: 0.01,
      },
      mapGridBBOX: [-121.55822753906251, 37.42797890822844, -120.67245483398438, 38.225235239076824],
      markerPosition: {},
      geojsonCircumStyle: {
        stroke: 'yellow',
        'stroke-width': 2,
        'stroke-opacity': 1,
        fill: '#555555',
        'fill-opacity': 0.01,
        weight: 1.2,
        opacity: 0.5,
        color: 'orange',
        dashArray: '3',
        fillOpacity: 0.01,
      },
      markerDetails: {
        lat: 0,
        lng: 0,
        objectCount: 0,
        radius: 0,
        geojson: null,
      },
      vwFootMarkerOptions: {
        riseOnHover: true,
      },
      selected: [],
      selectedCloudTower: {},
      selectedPreviewTower: { id: 0 },
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Latitude', value: 'lat' },
        { text: 'Longitude', value: 'lng' },
        { text: 'Objects', value: 'objectCount' },
        { text: 'Radius', value: 'radius' },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: 'Visible', value: 'visible', sortable: false },
      ],
      max25chars: v => v.length <= 25 || 'Input too long!',
      snack: false,
      snackColor: '',
      snackText: '',
      staticAnchor: [12, 41],
      dialog: false,
      dialogCloudDelete: false,
      dialogCloudTowerDetails: false,
      vwFootMapBounds: null,
      expandedItems: [],
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' },
      ],
    }),
    computed: {
      ...mapGetters(['cloudTowers', 'cloudTowerPreviews', 'towerHeights', 'smHeights']),

      markerLatLng: function () {
        return [this.markerPosition.lat, this.markerPosition.lng]
      },
    },
    watch: {
      isLoggedIn (n, o) {
        this.$router.push('/')
      },
    },
    mounted () {
      window.addEventListener('load', () => {
        // console.log('everything is loaded, lets do this');
        // run after everything is in-place
        // eslint-disable-next-line no-prototype-builtins
        if (this.$route.query.hasOwnProperty('tab')) {
          var tabIndex = this.$route.query.tab
          if (tabIndex >= 0) {
            this.activeTab = parseInt(tabIndex, 10)
          }
        }
      })
    },
    async created () {
      this.markerPosition = { lat: this.center[0], lng: this.center[1] }
      this.getCloudTowers()
      this.getCloudTowerConfigs()
    },
    methods: {
      ...mapActions(['heatDelTower', 'heatUpdateTower', 'updateCloudTower', 'heatUpdateCloudTowerVis', 'createCloudTower', 'deleteCloudTower', 'getCloudTowers', 'getCloudTowerConfigs']),

      async loadGeoJSON () {
        const payload = {
          lat: this.markerDetails.lat,
          lng: this.markerDetails.lng,
          radius: this.radius,
        }
        try {
          const { data } = await axios.get('https://devapi.velociter.net/api-map.php?endpoint=vw-heat&action=get-geojson-footprints&src_lat=' + payload.lat + '&src_lng=' + payload.lng + '&radius=' + payload.radius)
          console.log(data)
          this.geojson = data.response
          this.markerDetails.lat = payload.lat
          this.markerDetails.lng = payload.lng
          this.markerDetails.objectCount = data.response.features.length
          this.markerDetails.geojson = data.response
          this.markerDetails.radius = payload.radius
          console.log('length:' + this.markerDetails.objectCount)
          // alert("Location Loaded");
        } catch (error) {
          console.log(error)
        }
      },
      async onMapCentered (event) {
        // this.loadGeoJSON({lat: event.lat, lng:event.lng});
        // console.log(event);
      },
      async onMapClicked (event) {
        this.selectedPreviewTower = { id: 0 }
        this.drawerTowerDetails = true
        console.log('map clicked event')
        console.log(event)
        // console.log(this);
        console.log(this.vwFootMapBounds)
        const boundString = event.target.getBounds().toBBoxString()
        console.log(boundString)
        const params = {
          request: 'GetFeatureInfo',
          service: 'WMS',
          srs: 'EPSG:4326',
          // styles: this.wmsParams.styles,
          // transparent: this.wmsParams.transparent,
          // version: this.wmsParams.version,
          format: 'image/png',
          bbox: boundString,
          height: event.target._size.y,
          width: event.target._size.x,
          layers: 'tester:reverse_prins2-4mi_65ft_3ftsm',
          query_layers: 'tester:reverse_prins2-4mi_65ft_3ftsm',
          // info_format: 'text/html',
          x: event.containerPoint.x,
          y: event.containerPoint.y,
        }
        var str = []
        for (var p in params) {
          // eslint-disable-next-line no-prototype-builtins
          if (params.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]))
          }
        }
        const qs = str.join('&')
        console.log(qs)

        this.markerDetails.lat = event.latlng.lat
        this.markerDetails.lng = event.latlng.lng

        var center = [this.markerDetails.lng, this.markerDetails.lat]
        // console.log('center of circle');
        // console.log(center);
        var options = { steps: 150, units: 'miles', properties: { foo: 'bar' } }
        var circle = turf.circle(center, this.radius, options)

        // console.log(circle);
        this.geojsonCircum = circle
      },
      async onOverlayAdded (event) {
        console.log('overlay added fired')
      },
      async doAddTower (tower) {
        console.log(tower)
        const newTower = { ...tower }
        this.$store.dispatch('heatAddTower', newTower)
      },
      async doCreateCloudTower (tower) {
        console.log('Creating new cloud tower')
        console.log(tower)
        const newTower = { ...tower }
        delete newTower.geojson
        const response = await this.createCloudTower(newTower)
        console.log(response)
        if (response.success) {
          this.getCloudTowers()
        }
      },
      async doDeleteTower (tower) {
        this.heatDelTower(tower)
      },
      async doDeleteCloudTower (tower) {
        await this.deleteCloudTower(tower)
        await this.getCloudTowers()
        this.dialogCloudDelete = false
      },
      async doShowCloudTowerModalDel (tower) {
        this.dialogCloudDelete = true
        this.selectedCloudTower = tower
      },
      async doShowCloudTowerDetailsModal (tower) {
        this.dialogCloudTowerDetails = true
        this.selectedCloudTower = tower
        this.$nextTick(() => {
          this.$refs.cloudTowerDetails.doGetItems()
        })
      },
      async doViewTower (tower) {
        this.$refs.vwFootMap.setCenter([tower.lat, tower.lng])
        this.$refs.vwFootMap.setZoom(15)
        this.activeTab = 0
      },
      getMarkerPosFromTower (tower) {
        // console.log('getting marker position');
        // console.log(tower);
        return [tower.lat, tower.lng]
      },
      getMarkerPosFromPoint (point) {
        // console.log(point);
        return [point.geometry.coordinates[1], point.geometry.coordinates[0]]
      },
      getMarkerIconText (point, index) {
        const col = Math.floor(index / 28)
        const row = Math.floor(index - (col * 28))
        const letter = this.pointGridCols[col]
        return letter + '.' + row
      },
      getTowerOutline (tower) {
        var center = [tower.lng, tower.lat]
        // console.log('center of circle');
        // console.log(center);
        var options = { steps: 150, units: 'miles', properties: { foo: 'bar' } }
        var circle = turf.circle(center, tower.radius, options)
        return circle
      },
      async visibleChanged (tower) {
        console.log(tower)
        this.heatUpdateTower(tower)
      },
      async visibleChangedCloud (tower) {
        console.log(tower)
        this.heatUpdateCloudTowerVis(tower)
      },
      async vwFootMapReady () {
        // var cellSide = 2
        // var options = { units: 'miles' }

        // var squareGrid = turf.squareGrid(this.mapGridBBOX, cellSide, options)
      },
      saveTowerName (item) {
        console.log(item)
        this.heatUpdateTower(item)

        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved'
      },
      saveCloudTowerName (item) {
        console.log(item)
        this.updateCloudTower(item)

        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved'
      },
      cancel () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      open () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      close () {
        console.log('Dialog closed')
      },
      generateDownloadURL (tower, tHeight, smHeight) {
        const url = 'https://dev.velociter.net/api-map.php?endpoint=vw-heat&action=get-cnheat-csv-reverse&src_lat=' + tower.lat + '&src_lng=' + tower.lng + '&radius=' + tower.radius + '&tower_name=' + tower.name + '&tower_height=' + tHeight + '&sm_height=' + smHeight + '&tower_distance=3200'
        return url
      },
      async wmsClicked (event, layer) {
        console.log('layer clicked events and layer')
        console.log(event)
        console.log(layer)
        // const params = {
        //   request: 'GetFeatureInfo',
        //   service: 'WMS',
        //   srs: 'EPSG:4326',
        //   // styles: this.wmsParams.styles,
        //   // transparent: this.wmsParams.transparent,
        //   // version: this.wmsParams.version,
        //   format: this.wmsParams.format,
        //   bbox: this._map.getBounds().toBBoxString(),
        //   height: size.y,
        //   width: size.x,
        //   layers: this.wmsParams.layers,
        //   query_layers: this.wmsParams.layers,
        //   info_format: 'text/html',
        //   x: event.containerPoint.x,
        //   y: event.containerPoint.y,
        // }
      },
      async onCloudMarkerClicked (event) {
        console.log(event)
        this.selectedPreviewTower = event
        this.drawerTowerDetails = true
      },
      async onItemExpanded ({ item, value }) {
        console.log(this)
        console.log(item)
        item.expanded = value
        if (value) {
          this.$nextTick(() => { this.$refs['t' + item.rowkey].doGetItems() })

          // this.$refs['t' + item.rowkey].doGetItems();
        }
        // console.log(this.$refs['cloudTowerTable'])
      },
      async onTowerCreated (item) {
        console.log(item)
        this.cloudTowers.push(item)
        this.selectedPreviewTower = item
      },
    },
  }
</script>
